// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const Feed = require('client-v2/common/containers/feed/component-dumb')
const { createFeedSmartComponent } = require('client-v2/common/containers/feed/component-smart')
const createEmptyMessage = require('client-v2/common/containers/feed/empty-message')
// Sibling imports
const feedActions = require('./actions')
const feedSelectors = require('./selectors')

const commonFeedSmartComponent = createFeedSmartComponent(feedActions, feedSelectors)

function mapStateToProps(state, ownProps) {
  const commonFeedProps = commonFeedSmartComponent.mapStateToProps(state, ownProps)
  let emptyMessage
  if (!commonFeedProps.items.size) {
    emptyMessage = emptyMessageState(state)
  }
  return {
    ...commonFeedProps,
    emptyMessage
  }
}

module.exports = connect(
  mapStateToProps,
  commonFeedSmartComponent.mapDispatchToProps
)(
  withImmutableToJS(
    Feed
  )
)

// Empty message helpers

function emptyMessageState(state) {
  if (state.router.action === 'search.showDomainPosts') {
    return EmptyDomainPostsMessage
  }
  return EmptyQueryMessage
}

const EmptyDomainPostsMessage = createEmptyMessage(() => {
  return `Sorry, we could not find any content.`
})

const EmptyQueryMessage = createEmptyMessage(() => {
  return [
    'Sorry, we could not find any content.',
    'Consider broadening your search terms.'
  ].join('\n\n')
})
